/* istanbul ignore file */
/* eslint-disable */

export const responsiveProperties = {
  mobileBreakpoint: 600,
  tabletBreakpoint: 1024,
};
export const STICKY_MIN_YSCROLL = 160;
export const STICKY_MIN_SCROLL_HEIGHT = 350;
export const HUBS_ROOT_NODE_CLASS_NAME = 'react-hubs';
export const FCSUI_CLASS_NAME = 'fc-sui';
export const MOUNT_NODE = 'college-profile-portal';
export const MOUNT_NODE_ALT = 'college-profile-portal-alt';
export const ONLINE_SOME_PROGRAMS = 'Some distance learning opportunity';
export const ONLINE_ALL_PROGRAMS =
  'All programs offered completely via distance education';
export const USER_TYPE_STUDENT = 'STUDENT';
export const PERMISSIONS_PROSPECTIVE_COLLEGE = 'add_or_edit_prospective_colleges_list';
export const PARENT_PERMISSIONS_PROSPECTIVE_COLLEGE =
  'add_to_students_prospective_colleges_list';
export const PERMISSIONS_COLLEGE_STATISTICS = 'college_statistics';
export const PERMISSIONS_COLLEGE_EVENTS = 'active_match_events';
export const PERMISSIONS_COLLEGE_VISITS = 'college_visits';
export const PERMISSIONS_COLLEGE_OVERLAPS = 'college_match_universal_overlaps';
export const PERMISSIONS_PARENT = 'PARENT';
export const PERMISSION_SCHOLARSHIP_MATCH = 'scholarship_match';

export const validRoutes = [
  '/Overview',
  '/Studies',
  '/Student_Life',
  '/Admissions',
  '/Costs',
  '/Spotlights',
  '/Transfer',
];

export const MAX_CORE_SCREEN_WIDTH = 1004;
export const MAX_SMALL_SCREEN_WIDTH = 720;
